import 'select2';

export class OrgSearch {

    // Private variable for select
    $select;

    constructor(selector) {
        this.$select = $(selector);
        const url = this.$select.data("search-url");
        const placeholder = this.$select.data("search-label");

        this.$select.select2({
            minimumResultsForSearch: 10,
            dropdownAutoWidth: true,
            minimumInputLength: 1,
            width: "auto",
            placeholder: placeholder,
            ajax: {
                url: url,
                dataType: 'json',
                type: "GET",
                delay: 500,
                data: function (params) {
                    var query = {
                        'partialName': params.term
                    };
                    return query;
                },
                processResults: function (data) {
                    var select2Format = [];
                    Object.keys(data).forEach(function (key) {
                        var jsonData = {};
                        if (data[key].organizationId === '') data[key].organizationId = 'null';
                        jsonData['id'] = data[key].organizationId;
                        jsonData['text'] = data[key].name;
                        select2Format.push(jsonData);
                    });
                    return {
                        results: select2Format
                    };
                }
            }
        }).select2('open').select2('close').on("select2:select", (e) => {
            this.selectSuccess();
        }).on('select2:open', (e) => {
            // Code added to address focus issue created in version 3.3 of jQuery which steals focus away from Select2 element
            //@ts-ignore
            (list => list[list.length - 1])(document.querySelectorAll('.select2-container--open .select2-search__field')).focus();
        });
    }

    selectSuccess() {
        // Run any success methods here before user provided callback
        this.onSelectSuccess();
    }
    // Access to post share success method
    onSelectSuccess() { }

    resetSelect() {
        this.$select.val('').trigger('change');
    }
}